const USER_KEY = "relayrigs_user";

export const getUser = () => {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
};

// Only the (non-sensitive) user profile is kept client-side for UI display.
// The actual auth token lives in an httpOnly cookie set by the backend — it
// is never written to localStorage, so it can't be read by an XSS payload.
export const setSession = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event("relayrigs-auth-change"));
};

export const clearSession = () => {
  localStorage.removeItem(USER_KEY);
  window.dispatchEvent(new Event("relayrigs-auth-change"));
};
